import { render, staticRenderFns } from "./pricePopover.vue?vue&type=template&id=2c035ce6"
import script from "./pricePopover.vue?vue&type=script&lang=js"
export * from "./pricePopover.vue?vue&type=script&lang=js"
import style0 from "./pricePopover.vue?vue&type=style&index=0&id=2c035ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports